import { MockFactory } from '@tino-frontend/mocks'
import { Invoice } from '@types'

export const invoice = new MockFactory<Invoice>({
  id: 'invoice_id',
  amount_cents: 1000,
  invoice_created_at: '2021-01-01T00:00:00.000Z',
  limit_reservation_created_at: '2021-01-01T00:00:00.000Z',
  nfe_id: 'nfe_id',
  notes: 'Notes',
  xml_download_url: 'xml_download_url',
})
